export default __webpack_public_path__ + "static/prolific_defence-min-f7ab4ca1f0fb194ab14708fc7440da8c.png";